import * as zod from 'zod';

export const HaasRunProgramVariables = zod.object({
  isProgramComplete: zod.boolean(),
});

export type HaasRunProgramVariables = zod.infer<typeof HaasRunProgramVariables>;
